import {XauditModel} from '../xaudit.model';
import {AddressDataModel} from '../person/address-data.model';

export class TdoClientConfigurationModel extends XauditModel {
  EnterpriseID: string;
  Name: string;
  ShortName: string;
  OrganizationID: string;
  TDO12AWSServerName: string;
  TDOCID: number;
  TDOGUID: string;
  TDOWebPortalSubDomain: string;
  // TODO: Verify these are AddressDataModels
  cfgTDOClientOfficeLocations: AddressDataModel[];
  cfgTDOEnterprise: string;
  ARisEstimating: boolean;
  ARisComparing: boolean;
  SMSSendFromAddress: string;
  EmailReturnAddress: string;
  LogoReport_DocumentID: string;
  LogoLetter_DocumentID: string;
  LogoEmail_DocumentID: string;
  LogoXray_DocumentID: string;
  LogoXrayLocation: number;

  ARReportingOptionsJSON: string;
  isShowContractedFee: boolean;
  isShowStandardFee: boolean;
  isShowContactedAndStandard: boolean;

}
